// ACRY PRINT関連のステータス
const initialState = () => ({
  selectProductId: 0, // 選択したプロダクトID
  designData:null,
  cutlineData:null,
  frameCutlineData:null,
})

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    reset(state) {
      Object.assign(state, initialState())
    },
    set(state, { key, value }) {
      if (key in state) {
        state[key] = value;
      }
    },
  },
}
